export interface ATP3Criterion {
  id: string;
  name: string;
  description: string;
  threshold_male: string;
  threshold_female: string;
}

export const metabolicSyndromeCriteria: ATP3Criterion[] = [
  {
    id: 'waist',
    name: 'Perímetro Abdominal',
    description: 'Obesidad abdominal',
    threshold_male: '>102 cm',
    threshold_female: '>88 cm',
  },
  {
    id: 'triglycerides',
    name: 'Triglicéridos',
    description: 'Hipertrigliceridemia',
    threshold_male: '≥150 mg/dL',
    threshold_female: '≥150 mg/dL',
  },
  {
    id: 'hdl',
    name: 'HDL',
    description: 'HDL bajo',
    threshold_male: '<40 mg/dL',
    threshold_female: '<50 mg/dL',
  },
  {
    id: 'blood_pressure',
    name: 'Presión Arterial',
    description: 'PA elevada',
    threshold_male: 'PAS ≥130 o PAD ≥85 mmHg',
    threshold_female: 'PAS ≥130 o PAD ≥85 mmHg',
  },
  {
    id: 'fasting_glucose',
    name: 'Glucemia en Ayunas',
    description: 'Glucemia alterada en ayunas',
    threshold_male: '≥100 mg/dL',
    threshold_female: '≥100 mg/dL',
  },
];

export const metabolicThresholds = {
  waist_cm: { male: 102, female: 88 },
  triglycerides: 150,
  hdl: { male: 40, female: 50 },
  sbp: 130,
  dbp: 85,
  fasting_glucose: 100,
};
